import axios, { AxiosRequestConfig } from 'axios'

import { IShop } from '@/types/shop'
import { HttpError } from '@/constant/error'

export const getShops = async (phone: string): Promise<IShop[]> => {
  const config: AxiosRequestConfig = {
    params: {
      phone,
    },
  }
  try {
    const response = await axios.get<IShop[]>('shops', config)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.shops.getShops')
  }
}

export const getUncheckedShops = async (): Promise<IShop[]> => {
  try {
    const response = await axios.get<IShop[]>('shops/unchecked')
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.shops.getUncheckedShops')
  }
}

export const getCheckedShops = async (): Promise<IShop[]> => {
  try {
    const response = await axios.get<IShop[]>('shops/checked')
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.shops.getCheckedShops')
  }
}

export const postShop = async (shop: IShop): Promise<IShop> => {
  try {
    const response = await axios.post<IShop>('shops', shop)
    return response.data
  } catch (error) {
    // Access to config, request, and response
    throw new HttpError(
      'error.shops.postShop',
      (error as any)?.response?.status ?? 400,
    )
  }
}

export const putShop = async (shop: IShop): Promise<IShop> => {
  try {
    const response = await axios.put<IShop>(`shops/${shop.id}`, shop)
    return response.data
  } catch (error) {
    // Access to config, request, and response
    throw new HttpError(
      'error.shops.putShop',
      (error as any)?.response?.status ?? 400,
    )
  }
}
